import {
  makeStyles,
  tokens,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from '@fluentui/react-components';

import { getOttoEnv } from '@/services/envContext';

const useStyles = makeStyles({
  // Banner lives in the document flow at the top of the app shell so it
  // doesn't overlay the sticky header or the keyboard skip-link
  // (WCAG 2.4.11 Focus Not Obscured). The shell pushes the rest of the
  // app down by the banner's natural height.
  banner: {
    flexShrink: 0,
    borderRadius: tokens.borderRadiusNone,
  },
});

/**
 * Renders a warning banner at the top of the app when the portal is
 * running in the staging environment. Slot detection comes from
 * `getOttoEnv()`, which prefers the ACA-injected `<meta name="otto-env">`
 * value and falls back to the `?env=staging` URL flag. Returns null in
 * production.
 *
 * Mounted inside the app shell so it occupies its own row above the
 * sticky header rather than overlaying it.
 */
export const StagingBanner = () => {
  const styles = useStyles();

  if (getOttoEnv() !== 'staging') {
    return null;
  }

  return (
    <MessageBar intent="warning" className={styles.banner}>
      <MessageBarBody>
        <MessageBarTitle>STAGING ENVIRONMENT</MessageBarTitle>
        Test traffic. Changes here use the staging Portal build but the production runtime backend and your real Azure data.
      </MessageBarBody>
    </MessageBar>
  );
};
